import { render, staticRenderFns } from "./auditionList.vue?vue&type=template&id=2565b86a&scoped=true&"
import script from "./auditionList.vue?vue&type=script&lang=js&"
export * from "./auditionList.vue?vue&type=script&lang=js&"
import style0 from "./auditionList.vue?vue&type=style&index=0&id=2565b86a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2565b86a",
  null
  
)

export default component.exports